// extracted by mini-css-extract-plugin
module.exports = {"wordGlyph":"WordGlyph_wordGlyph__zczVr","content":"WordGlyph_content__3Z1xh","item":"WordGlyph_item__37iCg","audio":"WordGlyph_audio__10eSQ","image":"WordGlyph_image__Yd3Af"};